var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow-y":"scroll","padding-bottom":"20pt"}},_vm._l((_vm.maschinesNotifications),function(maschine){return _c('maschine-ew-frame',{key:maschine.key,attrs:{"maschine":maschine,"ewframes":maschine.ewframes,"filter":''}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }